/* Muted autoplay film, paused off screen and when the page is hidden. */
const main = document.querySelector('#main');
const films = new Map();
let scanQueued = false;

function sync(record) {
  if (record.failed) return;
  const wanted = record.visible && !document.hidden;
  if (wanted && record.video.paused) {
    const result = record.video.play();
    result?.catch(() => {});
  } else if (!wanted && !record.video.paused) record.video.pause();
}

const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
  for (const entry of entries) {
    const record = films.get(entry.target);
    if (!record) continue;
    record.visible = entry.isIntersecting;
    sync(record);
  }
}, { threshold: .2 }) : null;

function scan() {
  scanQueued = false;
  for (const [video] of films) {
    if (!video.isConnected) {
      video.pause();
      observer?.unobserve(video);
      films.delete(video);
    }
  }
  main.querySelectorAll('[data-campaign-film]').forEach(video => {
    if (films.has(video)) return;
    const record = { video, visible: !observer };
    films.set(video, record);
    video.muted = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;
    video.addEventListener('error', () => {
      record.failed = true;
      video.pause();
      video.hidden = true;
      const poster = video.parentElement.querySelector('.campaign-poster');
      if (poster) poster.hidden = false;
    });
    if (observer) observer.observe(video);
    sync(record);
  });
}

function syncAll() { films.forEach(sync); }
new MutationObserver(() => {
  if (scanQueued) return;
  scanQueued = true;
  queueMicrotask(scan);
}).observe(main, { childList: true, subtree: true });
document.addEventListener('visibilitychange', syncAll);
scan();
